{
  "name": "fatrain-collect-ui",
  "version": "25.5.1",
  "scripts": {
    "ng": "ng",
    "serve": "ng serve --configuration=development",
    "start-test": "ng serve --configuration=test",
    "start": "ng serve --configuration=development -o",
    "build": "ng build --aot=true --output-hashing=all --progress=true --verbose=true",
    "build-test": "ng build --configuration=test",
    "build-qa": "ng build --configuration=qa",
    "build-prod": "ng build --configuration=prod",
    "test-coverage": "ng test --code-coverage --watch=false --browsers=ChromeHeadless",
    "singletest-chrome": "ng test --include=**/fatrain.service.spec.ts --code-coverage --browsers=Chrome",
    "singletest": "ng test --include=**/fatrain.service.spec.ts --code-coverage --browsers=ChromeHeadless",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.3",
    "@angular/cdk": "^22.2.3",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/material": "^22.2.3",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@microsoft/applicationinsights-web": "^3.3.6",
    "@ng-idle/core": "^16.0.0",
    "@ng-idle/keepalive": "^16.0.0",
    "angular-oauth2-oidc": "^15.0.1",
    "font-awesome": "^4.7.0",
    "lodash.range": "^3.2.0",
    "moment": "^2.29.4",
    "moment-timezone": "^0.5.48",
    "postcss": "^8.5.3",
    "pretty-checkbox": "^3.0.3",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.2.3",
    "@angular/cli": "^22.2.3",
    "@angular/compiler-cli": "^22.2.3",
    "@compodoc/compodoc": "^1.1.26",
    "@types/jasmine": "~4.3.4",
    "@types/lodash.range": "^3.2.6",
    "@types/node": "^20.17.30",
    "angular-eslint": "^22.6.0",
    "eslint": "^10.13.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "^5.6.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.1.1",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "ng-mocks": "^14.18.4",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.72.0"
  },
  "overrides": {
    "vite": "^8.3.5",
    "picomatch": "^4.0.4"
  }
}
